import { render, staticRenderFns } from "./addFllowUp.vue?vue&type=template&id=951dae30&scoped=true&"
import script from "./addFllowUp.vue?vue&type=script&lang=js&"
export * from "./addFllowUp.vue?vue&type=script&lang=js&"
import style0 from "./addFllowUp.vue?vue&type=style&index=0&id=951dae30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951dae30",
  null
  
)

export default component.exports